import { AxiosRequestConfig} from "axios";
import httpClient from "./http.config";

class HttpService {

 public async get<T>(url: string, options: AxiosRequestConfig): Promise<T> {
   return (await httpClient.get<T>(url, options)).data;
 }

 public async post<T, P>(url: string, payload: P, options: AxiosRequestConfig): Promise<T> {
   return (await httpClient.post<T>(url, payload, options)).data;
 }

 public async update<T, P>(url: string, payload: P, options: AxiosRequestConfig): Promise<T> {
   return (await httpClient.put<T>(url, payload, options)).data;
 }

 public async patch<T, P>(url: string, payload: P, options: AxiosRequestConfig): Promise<T> {
   return (await httpClient.patch<T>(url, payload, options)).data;
 }

 public async remove<T>(url: string, options: AxiosRequestConfig): Promise<T> {
   return (await httpClient.delete<T>(url, options)).data;
 }
}

export { HttpService as default };


